import * as React from "react"
//@ts-ignore
import * as homeStyle from "../styles/home.module.scss";
import { Layout } from "../components/layout";
import { StaticImage } from "gatsby-plugin-image"
import { GitLogo, ReactLogo, TypescriptLogo, NodeJSLogo, WebpackJSLogo } from '../components/SVG/skills';
import { works } from '../utils/data';
import axios from "axios";
//@ts-ignore
import curriculum from '../downloadable/CurriculumVitae.pdf';
const { useRef, useCallback, useState } = React;

const intersectionCallback = (observer, setFlag, options) => {
  return node => {
    if (observer.current) observer.current.disconnect();
    //@ts-ignore
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) setFlag(false);
      else setFlag(true);
    }, options);
    if (node) observer.current.observe(node);
  }
}

// markup
const IndexPage = () => {
  const [visibleNav, setVisibleNav] = useState(false);
  const [visibleTitle, setVisibleTitle] = useState(true);
  const [visibleSubTitle, setVisibleSubTitle] = useState(true);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  const navObserver = useRef(null);
  const homeTitleObserver = useRef(null);
  const homeSubTitleObserver = useRef(null);

  const homeTitle = useCallback(intersectionCallback(homeTitleObserver, setVisibleTitle, { rootMargin: "-200px 0px" }),
    [visibleTitle]);
  const homeSubTitle = useCallback(intersectionCallback(homeSubTitleObserver, setVisibleSubTitle, { rootMargin: "-200px 0px" }),
    [visibleSubTitle]);
  const navigator = useCallback(intersectionCallback(navObserver, setVisibleNav, { rootMargin: "-100px" }),
    [visibleNav]);

  const onChange = (e) => {
    setForm(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
  }

  const handleForm = (e) => {
    const { email, message, name } = form;
    e.preventDefault();
    const url = "https://formspree.io/f/xaylrrpj";
    axios.post(url, { email, message, name }, { headers: { 'Accept': 'application/json' } })
      .then(() => setSent(true));
  }

  return (
    <Layout visibleNav={visibleNav}>
      <div ref={navigator} className={homeStyle.navTrigger}></div>
      <section id="home" className={homeStyle.homeSection}>
        <div className={homeStyle.homeContent}>
          <h1 ref={homeTitle} className={visibleTitle ? "" : homeStyle.active}>Hi, I'm <span>Kevin Cheng</span></h1>
          <h1 ref={homeSubTitle} className={visibleSubTitle ? "" : homeStyle.active}>A Front-end and Back-end Developer</h1>
          <button className={homeStyle.button}>
            <a href={curriculum} target="_blank" download>CHECK CV</a>
          </button>
        </div>
      </section>
      <section id="works" className={`${homeStyle.workSection} ${homeStyle.section}`}>
        <h1 className={homeStyle.title}>P R O J E C T S</h1>
        <div className={homeStyle.worksGrid}>
          {works.map((work, idx) => (
            <div key={`${work.name}-${idx}`} className={homeStyle.workItem}>
              {work.component}
              <div className={homeStyle.workInfo}>
                <h2>{work.name}</h2>
                <h3>{work.stack.join(" / ")}</h3>
              </div>
              <div className={homeStyle.learnMoreBlock}>
                {work.linkLive ?
                  <a href={work.linkLive} target="_blank"><button className={homeStyle.button}>L I V E</button></a>
                  :
                  ""
                }
                {work.linkCode ?
                  <a href={work.linkCode} target="_blank"><button className={homeStyle.button}>C O D E</button></a>
                  :
                  ""
                }
              </div>
            </div>
          ))}
        </div>
      </section>
      <section id="about" className={`${homeStyle.section} ${homeStyle.aboutSection}`}>
        <h1 className={homeStyle.title}>A B O U T</h1>
        <div className={homeStyle.aboutBlock}>
          <div className={homeStyle.aboutPhoto}>
            <StaticImage
              className={homeStyle.workImg}
              src="../images/portrait.png"
              alt="portrait" />
          </div>
          <div className={homeStyle.aboutText}>
            <h2>Hi, I'm Kevin, nice to meet you!</h2>
            <h3>
              <span>Developer</span>
              <span>Programmer</span>
            </h3>
            <p>I'm a Informatics Engineering student based in Venezuela.
            I have worked in quite a number of projects and my major
            focus is on Web apps.
            </p>
            <div className={homeStyle.aboutSkills}>
              <h2>Skills</h2>
              <div className={homeStyle.aboutListSkills}>
                <span><ReactLogo className={homeStyle.skillLogo} /></span>
                <span><NodeJSLogo className={homeStyle.skillLogo} /></span>
                <span><TypescriptLogo className={homeStyle.skillLogo} /></span>
                <span><WebpackJSLogo className={homeStyle.skillLogo} /></span>
                <span><GitLogo className={homeStyle.skillLogo} /></span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="contact" className={`${homeStyle.section} ${homeStyle.contactSection} ${homeStyle.invertedSection}`}>
        <h1 className={`${homeStyle.title} ${homeStyle.titleInverted}`}>C O N T A C T</h1>
        {sent ?
          <h3>Gracias por contactarme!</h3>
          :
          <form onSubmit={handleForm} className={homeStyle.contactForm}>
            <input onChange={onChange} autoComplete="off" placeholder="Name" type="text" name="name" className={homeStyle.nameField} id="name" />
            <input onChange={onChange} autoComplete="off" placeholder="Enter email" type="email" name="email" className={homeStyle.emailField} id="email" />
            <textarea onChange={onChange} placeholder="Your Message" name="message" id="message" className={homeStyle.messageField} cols={30} rows={10}></textarea>
            <button className={homeStyle.button}>Send</button>
          </form>
        }
      </section>
    </Layout>
  )
}

export default IndexPage
